import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-8" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "d-flex justify-content-between align-items-center mb-4" }
const _hoisted_4 = {
  key: 0,
  style: {"height":"300px"},
  class: "d-flex align-items-center justify-content-center"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 2,
  class: "categories-vertical"
}
const _hoisted_7 = { class: "category-header d-flex align-items-center justify-content-between" }
const _hoisted_8 = { class: "d-flex align-items-center" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "category-title" }
const _hoisted_13 = { class: "badge bg-light text-muted fs-8" }
const _hoisted_14 = { class: "codes-grid" }
const _hoisted_15 = ["disabled", "onClick"]
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  key: 1,
  class: "spinner-border spinner-border-sm"
}
const _hoisted_18 = { class: "code-text" }
const _hoisted_19 = { class: "dialog-footer" }

import { ref, onMounted, computed } from "vue";
import RebateService from "../services/RebateService";
import ScaleLoader from "vue-spinner/src/ScaleLoader.vue";
import HeaderMenu from "../../Payment/components/HeaderMenu.vue";
import { ElMessageBox } from "element-plus";

// Tabs config

export default /*#__PURE__*/_defineComponent({
  __name: 'ProductsList',
  setup(__props) {

const TabStatus = {
  Schema: 400,
  Rebate: 300,
};

const currentType = ref<number>(TabStatus.Schema);

const headerMenuRef = ref();

const isLoading = ref(true);
const tableData = ref<any[]>([]);

const showAddModal = ref(false);
const addForm = ref<{
  code: string;
  categoryId: number | null;
  category: string;
}>({
  code: "",
  categoryId: null,
  category: "",
});
const addLoading = ref(false);
const collapsed = ref<Record<string, boolean>>({});
const deleteLoading = ref<Record<string | number, boolean>>({});

const fetchAll = async () => {
  isLoading.value = true;
  try {
    tableData.value = await RebateService.getSymbolsList({
      type: currentType.value,
    });
    collapsed.value = {};
    tableData.value.forEach((item) => {
      const cat = item.category || "Uncategorized";
      if (collapsed.value[cat] === undefined) collapsed.value[cat] = false;
    });
  } catch (e) {
    console.log(e);
  } finally {
    isLoading.value = false;
  }
};

onMounted(fetchAll);

const changeTab = (_tab: any) => {
  currentType.value = _tab;
  fetchAll();
};

const refresh = () => fetchAll();

const groupedByCategory = computed<Record<string, any>>(() => {
  const map: Record<string, any[]> = {};
  tableData.value.forEach((item) => {
    const cat = item.category || "Uncategorized";
    (map[cat] ||= []).push(item);
  });
  return map;
});

const categoryOptions = computed(() => {
  const map: Record<string, number | null> = {};
  tableData.value.forEach((item: any) => {
    const name = item.category || "Uncategorized";
    const id = item.categoryId ?? item.CategoryId ?? item.category_id ?? null;
    if (map[name] === undefined) map[name] = id;
  });
  return Object.keys(map).map((name) => ({
    label: name,
    id: map[name],
  }));
});

const onCategorySelect = (val: string) => {
  const found = categoryOptions.value.find((o) => o.label === val);
  addForm.value.categoryId = found ? (found.id as number | null) : null;
};

const openAddSymbol = () => {
  addForm.value = { code: "", categoryId: null, category: "" };
  showAddModal.value = true;
};

const submitAddSymbol = async () => {
  if (
    !addForm.value.code ||
    addForm.value.category === "" ||
    addForm.value.categoryId === null
  )
    return;
  addLoading.value = true;
  try {
    await RebateService.addSymbol({
      Code: addForm.value.code,
      CategoryId: addForm.value.categoryId,
      Category: addForm.value.category,
      type: currentType.value,
    });
    showAddModal.value = false;
    refresh();
  } catch (e) {
    console.log(e);
  } finally {
    addLoading.value = false;
  }
};

const toggleCategory = (cat: string) => {
  collapsed.value[cat] = !collapsed.value[cat];
};

const deleteSymbol = async (item: any) => {
  const key = item.id;
  if (!key || deleteLoading.value[key]) return;
  deleteLoading.value[key] = true;
  try {
    await RebateService.deleteSymbol(key);
    refresh();
  } catch (e) {
    console.log(e);
  } finally {
    deleteLoading.value[key] = false;
  }
};

const confirmDelete = async (item: any) => {
  try {
    await ElMessageBox.confirm(`Delete symbol ${item.code}?`, "Confirm", {
      confirmButtonText: "OK",
      cancelButtonText: "Cancel",
      confirmButtonClass: "normal-confirm-btn",
      customClass: "symbol-delete-confirm",
      distinguishCancelAndClose: true,
    });
    deleteSymbol(item);
  } catch {
    /* canceled */
  }
};

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(HeaderMenu, {
          tabs: TabStatus,
          onChangeTab: changeTab,
          ref_key: "headerMenuRef",
          ref: headerMenuRef
        }, null, 512),
        _createElementVNode("button", {
          class: "btn btn-primary btn-add-large",
          onClick: openAddSymbol
        }, _toDisplayString(_ctx.$t("action.add")), 1)
      ]),
      (isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(ScaleLoader)
          ]))
        : (tableData.value.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t("tip.nodata")), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedByCategory.value, (items, category) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: category,
                  class: "category-block"
                }, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("button", {
                        class: "collapse-toggle btn btn-light btn-sm me-3",
                        type: "button",
                        onClick: ($event: any) => (toggleCategory(category))
                      }, [
                        (collapsed.value[category])
                          ? (_openBlock(), _createElementBlock("span", _hoisted_10, "+"))
                          : (_openBlock(), _createElementBlock("span", _hoisted_11, "-"))
                      ], 8, _hoisted_9),
                      _createElementVNode("span", _hoisted_12, _toDisplayString(category), 1)
                    ]),
                    _createElementVNode("span", _hoisted_13, _toDisplayString(items.length), 1)
                  ]),
                  _createVNode(_Transition, { name: "fade" }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("div", _hoisted_14, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items, (item) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: item.id,
                            class: "code-card"
                          }, [
                            _createElementVNode("button", {
                              class: "symbol-delete",
                              disabled: deleteLoading.value[item.id],
                              onClick: _withModifiers(($event: any) => (confirmDelete(item)), ["stop"]),
                              title: "Delete"
                            }, [
                              (!deleteLoading.value[item.id])
                                ? (_openBlock(), _createElementBlock("span", _hoisted_16, "×"))
                                : (_openBlock(), _createElementBlock("span", _hoisted_17))
                            ], 8, _hoisted_15),
                            _createElementVNode("span", _hoisted_18, _toDisplayString(item.code), 1)
                          ]))
                        }), 128))
                      ], 512), [
                        [_vShow, !collapsed.value[category]]
                      ])
                    ]),
                    _: 2
                  }, 1024)
                ]))
              }), 128))
            ]))
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: showAddModal.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((showAddModal).value = $event)),
      title: _ctx.$t('title.addSymbol'),
      width: "420px"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_19, [
          _createVNode(_component_el_button, {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (showAddModal.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("action.cancel")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: submitAddSymbol,
            loading: addLoading.value
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("action.save")), 1)
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
          "label-width": "110px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('fields.category')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: addForm.value.category,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((addForm.value.category) = $event)),
                  placeholder: _ctx.$t('fields.selectCategory'),
                  filterable: "",
                  style: {"width":"100%"},
                  onChange: onCategorySelect
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categoryOptions.value, (opt) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: opt.id || opt.label,
                        label: opt.label,
                        value: opt.label
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('fields.code')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: addForm.value.code,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((addForm.value.code) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ]))
}
}

})